import React, { useState, useRef, useEffect } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { IoSearchOutline } from "react-icons/io5";

const CustomDropdown = ({ title, options, onSelect, selectedOption, className, searchable = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const containerRef = useRef(null);
  const searchRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen && searchable && searchRef.current) {
      searchRef.current.focus();
    }
    if (!isOpen) {
      setSearchQuery("");
    }
  }, [isOpen, searchable]);

  const filteredOptions = searchable
    ? options.filter((opt) =>
        opt.label.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : options;

  return (
    <div className="hs-dropdown relative" ref={containerRef}>
      <button
        onClick={toggleDropdown}
        type="button"
        className={`hs-dropdown-toggle flex justify-between w-full py-2.5 px-4 items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-400 bg-white text-black shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50 ${className}`}
        aria-haspopup="menu"
        aria-expanded={isOpen}
      >
        {selectedOption || title}
        <IoIosArrowDown
          className={`transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {isOpen && (
        <div
          className="absolute w-full z-40 bg-white shadow-md border border-gray-300 rounded-lg mt-1"
          role="menu"
          aria-orientation="vertical"
        >
          {searchable && (
            <div className="p-2 border-b border-gray-200">
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-gray-300 bg-gray-50">
                <IoSearchOutline className="text-gray-400 shrink-0" size={15} />
                <input
                  ref={searchRef}
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search..."
                  className="w-full text-sm bg-transparent outline-none text-gray-700 placeholder-gray-400"
                />
              </div>
            </div>
          )}

          <div className="p-1 space-y-0.5 max-h-72 overflow-y-auto">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => (
                <button
                  key={index}
                  onClick={() => {
                    onSelect(option);
                    setIsOpen(false);
                  }}
                  className="w-full flex items-center gap-x-3.5 py-2 px-3 font-medium rounded-lg text-sm text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-100"
                >
                  {option.label}
                </button>
              ))
            ) : (
              <p className="py-3 px-3 text-sm text-gray-400 text-center">No results found</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
